import ArticleLayout from "@/components/feature/ArticleLayout";
import { newArticles } from "@/mocks/articles";

export default function ErrosComunsHoobuy() {
  return <ArticleLayout article={newArticles[5]} />;
}